import { navLinkListener } from './navigation';

document.addEventListener('DOMContentLoaded', () => {
  navLinkListener();
});
